import PropTypes from 'prop-types';

import fail from '../../../assets/images/failIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function ErrorOrderPopup({ onRequestClose }) {
  const dispatch = useAppDispatch();
  // const error = useAppSelector((state) => state.orders.error); //можно будет выводить ошибку в попап

  // Навигация на '/orders' и очистка sessionStorage.order происходят
  // централизованно в ModalWrapper через onCloseHref/
  // onCloseClearOrderSession (см. место, где открывается этот попап) -
  // одинаково для крестика, кнопки "Хорошо", клика по фону и Escape.
  // см. комментарий в SuccessPopup - onRequestClose приходит из
  // ModalWrapper и применяет onCloseHref/onCloseClearOrderSession.
  const handleClosePopup = onRequestClose || (() => dispatch(closePopup()));

  return (
    <div className={styles.orderSuccessPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.orderSuccessTextWrapper}>
        <img src={fail} alt="иконка неудачи, красный крест" />
        <h2 className={styles.orderSuccessTitle}>Заказ не удалось обновить!</h2>
        <h3 className={styles.orderSuccessSubTitle}>Попробуйте изменить заказ позже</h3>
        {/* <p>{error}</p> */}
      </div>
      <RedButton text="Хорошо" width={308} height={50} onClick={handleClosePopup} />
    </div>
  );
}

ErrorOrderPopup.propTypes = {
  onRequestClose: PropTypes.func,
};

export default ErrorOrderPopup;
